const InOutLog = {

    // FIELDS
    "premise": "Premise",
    "type": "Type",
    "sub_type": "Sub Type",
    "from_date": "From Date",
    "to_date": "To Date",
    "status": "Status",

    // STATUS OPTIONS
    "status_in": "In",
    "status_out": "Out",
    "status_pending": "Pending",
    "status_reject": "Reject",

    // BUTTON
    "generate": "Generate",

    // TOAST
    "success": "Generated Successfully",

    // TOOLTIP
    "preview": "Preview",

    // PAGE HEADER
    "in_out_report": "In Out Report",

    // ERROR
    "error_premise": "Select Premise",
    "error_type": "Select Type",
    "error_sub_type": "Select Sub Type",
    "error_from_date": "Choose From Date",
    "error_to_date": "Choose To Date",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_premise": "PREMISE",
    "table_type": "TYPE",
    "table_sub_type": "SUB TYPE",
    "table_from_date": "FROM DATE",
    "table_to_date": "TO DATE",
    "table_status": "STATUS",
    "table_generated_d&t": "GENERATED D&T",

}

export default InOutLog;